import React from "react";
import AppBar from "@material-ui/core/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@material-ui/core/ListItemText";
import {BASE_URL, BASE_URL_API, MARKET_BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {BasketComponent} from "./BasketComponent";
import {InputBase} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import {Link} from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import {ProductStructList} from "../structs/ProductStructList";
import {ProductStruct} from "../structs/ProductStruct";
import Box from "@material-ui/core/Box";
import {MarketStructList} from "../structs/MarketStructList";
import {MarketStruct} from "../structs/MarketStruct";
import CircularProgress from "@mui/material/CircularProgress";
import {BackButton} from "./HookUtils";

function bubbleSort(arr, n) {
    var i, j, temp;
    var swapped;
    for (i = 0; i < n - 1; i++) {
        for (j = 0; j < n - i - 1; j++) {
            if (arr[j].productList.length < arr[j + 1].productList.length) {
                // Swap arr[j] and arr[j+1]
                temp = arr[j];
                arr[j] = arr[j + 1];
                arr[j + 1] = temp;
                swapped = true;
            }
        }

        // IF no two elements were
        // swapped by inner loop, then break
    }

    return arr
}


function bubbleSortMarket(arr, n) {
    var i, j, temp;
    var swapped;
    for (i = 0; i < n - 1; i++) {
        for (j = 0; j < n - i - 1; j++) {
            if (arr[j].marketList.length < arr[j + 1].marketList.length) {
                // Swap arr[j] and arr[j+1]
                temp = arr[j];
                arr[j] = arr[j + 1];
                arr[j + 1] = temp;
                swapped = true;
            }
        }

        // IF no two elements were
        // swapped by inner loop, then break
    }

    return arr
}

export class SearchComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchResultProduct: [],
            searchResultMarket: [],
            value: 0,
            open: false,
            isLoading: true,

        }

    }


    FormPropsSearchFields = () => {

        const useStyles = makeStyles(theme => ({
            root: {
                "$ > *": {
                    margin: theme.spacing(),
                }
            },
            inputBase: {
                border: '2px solid rgb(232,232,232)',
                borderRadius: theme.shape.borderRadius,
                height: "6vh",
                background: 'rgb(232,232,232,.5)',
                padding: theme.spacing(2),
                color: 'rgb(0,0,0)'
            }
        }));

        const handleOnchange = (e) => {
            this.setState({isLoading:true})

            if (e.target.value.length >= 0)
                fetch(BASE_URL_API + 'search?q=' + e.target.value, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(results => {

                            if (results.code === 200) {
                                let data = new ProductStructList();

                                for (let i = 0; i < results.data.products.length; i++) {
                                    if (data.productList.length > 0) {
                                        let size = data.productList.length;
                                        for (let j = 0; j < size; j++) {
                                            if (results.data.products[i].category !== null && data.productList[j].category === results.data.products[i].category.title) {
                                                data.productList[j].productList.push(results.data.products[i])

                                                break
                                            } else {
                                                if (j === data.productList.length - 1) {
                                                    if (results.data.products[i].category != null) {
                                                        let productStruct = new ProductStruct()
                                                        productStruct.category = results.data.products[i].category.title
                                                        productStruct.productList.push(results.data.products[i])
                                                        data.productList.push(productStruct)
                                                    }


                                                }
                                            }
                                        }
                                    } else {
                                        if (results.data.products[i].category != null) {
                                            let productStruct = new ProductStruct()
                                            productStruct.category = results.data.products[i].category.title
                                            productStruct.productList.push(results.data.products[i])
                                            data.productList.push(productStruct)
                                        }

                                    }


                                }

                                let marketData = new MarketStructList();

                                for (let i = 0; i < results.data.markets.length; i++) {
                                    if (marketData.marketList.length > 0) {
                                        let size = marketData.marketList.length;
                                        for (let j = 0; j < size; j++) {
                                            if (results.data.markets[i].category !== null && marketData.marketList[j].category === results.data.markets[i].category.title) {
                                                marketData.marketList[j].marketList.push(results.data.markets[i])

                                                break
                                            } else {
                                                if (j === marketData.marketList.length - 1) {
                                                    let marketStruct = new MarketStruct()
                                                    marketStruct.category = results.data.markets[i].category.title
                                                    marketStruct.marketList.push(results.data.markets[i])
                                                    marketData.marketList.push(marketStruct)

                                                }
                                            }
                                        }
                                    } else {
                                        let marketStruct = new MarketStruct()
                                        marketStruct.category = results.data.markets[i].category.title
                                        marketStruct.marketList.push(results.data.markets[i])
                                        marketData.marketList.push(marketStruct)
                                    }


                                }

                                this.setState({isLoading:false})

                                this.setState({
                                    searchResultProduct: bubbleSort(data.productList, data.productList.length)
                                    ,
                                    searchResultMarket: bubbleSortMarket(marketData.marketList, marketData.marketList.length)
                                })


                            }

                        },
                        (error) => {
                            console.log("error")
                        }
                    );
        }

        const classes = useStyles();

        return (
            <InputBase style={{
                width: '98%',
                marginBottom: 16
            }}
                       className={classes.inputBase}
                       id="standard-bare"
                       variant="outlined"
                       onChange={handleOnchange}
                       placeholder="جستجو کالا و فروشگاه..."
            />
        );
    }

    componentDidMount() {
        fetch(BASE_URL_API + 'search?q=', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code === 200) {
                        let data = new ProductStructList();

                        for (let i = 0; i < results.data.products.length; i++) {
                            if (data.productList.length > 0) {
                                let size = data.productList.length;
                                for (let j = 0; j < size; j++) {
                                    if (results.data.products[i].category !== null && data.productList[j].category === results.data.products[i].category.title) {
                                        data.productList[j].productList.push(results.data.products[i])

                                        break
                                    } else {
                                        if (j === data.productList.length - 1) {
                                            if (results.data.products[i].category != null) {
                                                let productStruct = new ProductStruct()
                                                productStruct.category = results.data.products[i].category.title
                                                productStruct.productList.push(results.data.products[i])
                                                data.productList.push(productStruct)
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (results.data.products[i].category != null) {
                                    let productStruct = new ProductStruct()
                                    productStruct.category = results.data.products[i].category.title
                                    productStruct.productList.push(results.data.products[i])
                                    data.productList.push(productStruct)
                                }

                            }


                        }

                        let marketData = new MarketStructList();

                        for (let i = 0; i < results.data.markets.length; i++) {
                            if (marketData.marketList.length > 0) {
                                let size = marketData.marketList.length;
                                for (let j = 0; j < size; j++) {
                                    if (results.data.markets[i].category !== null && marketData.marketList[j].category === results.data.markets[i].category.title) {
                                        marketData.marketList[j].marketList.push(results.data.markets[i])

                                        break
                                    } else {
                                        if (j === marketData.marketList.length - 1) {
                                            let marketStruct = new MarketStruct()
                                            marketStruct.category = results.data.markets[i].category.title
                                            marketStruct.marketList.push(results.data.markets[i])
                                            marketData.marketList.push(marketStruct)

                                        }
                                    }
                                }
                            } else {
                                let marketStruct = new MarketStruct()
                                marketStruct.category = results.data.markets[i].category.title
                                marketStruct.marketList.push(results.data.markets[i])
                                marketData.marketList.push(marketStruct)
                            }


                        }


                        this.setState({
                            searchResultProduct: bubbleSort(data.productList, data.productList.length)
                            , searchResultMarket: bubbleSortMarket(marketData.marketList, marketData.marketList.length)
                        })

                        this.setState({isLoading:false})


                    }

                },
                (error) => {
                    console.log("error")
                }
            );


    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue})
    };

    handleDrawerClose = () => {
        this.setState({open: false})
    };

    handleDrawerOpen = () => {
        this.setState({open: true})
    };

    render() {

        const flexContainer = {
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
            overflowY: 'hidden',
            height: 260,
            background: 'rgba(238,238,238,0.3)',
            align: 'right'
        };

        const MAX_LENGTH = 25;

        if (localStorage.getItem("pwa_token") === null) {
            window.location.assign(BASE_URL + 'verify');
        }

        return <React.Fragment>

            <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                <ToolbarMui>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="end"
                        sx={{...(this.state.open && {display: 'none'})}}>

                    </IconButton>

                    <ListItemText align="center"><strong style={{
                        fontSize: 18,
                        overflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: 'black'
                    }}>{"Hamekara"}</strong></ListItemText>

                    <IconButton style={{color: 'black'}}> <BasketComponent/></IconButton>

                    <BackButton/>
                </ToolbarMui>

                <div align='center'>
                    <this.FormPropsSearchFields/>
                </div>

            </AppBar>



            <Box style={{marginTop: 150}}>
                <div    align='center'>
                    {this.state.isLoading===true ?  (
                        <CircularProgress  style={{
                            align: 'center'
                        }} />
                    ) : ''}

                </div>
                {
                    this.state.searchResultProduct.map((product) => (
                        <Box key={product.id} style={{overflowX: 'hidden', overflowY: 'hidden', height: 320}}>
                            <ListItemText style={{margin:16}}><strong>{product.category}</strong></ListItemText>

                            <List key={product.id} style={flexContainer}>
                                {product.productList.map((product) => (

                                    <ListItem key={product.id} style={{width: 250}} component={Link}
                                              to={"/product/?id=" + product.id}>

                                        <Box style={{width: 150}}>
                                            <Paper style={{
                                                width: 150,
                                                height: 140,
                                                align: 'center',
                                                backgroundPosition: 'center',
                                                backgroundSize: 'cover',
                                                backgroundImage: 'url(' + (product.pictures.length > 0 ? PRODUCT_BASE_URL_API + product.pictures[0].url : "https://hamekara.com/hamekara-logo.png") + ')'
                                            }}>


                                            </Paper>
                                            <ListItemText>
                                                {product.title.length > MAX_LENGTH ?
                                                    (
                                                        <p key={product.id} style={{
                                                            fontSize: 14,
                                                            overflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            color: 'black'
                                                        }}
                                                           align='center'><strong>{`${product.title.substring(0, MAX_LENGTH)}...`}</strong></p>
                                                    ) :
                                                    <p key={product.id} style={{
                                                        fontSize: 14,
                                                        overflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        color: 'black'
                                                    }}
                                                       align='right'><strong>{product.title}</strong></p>
                                                }

                                                { product.markets!==null ?
                                                    (
                                                        <p key={product.id} style={{
                                                            fontSize: 10,
                                                            overflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            color: 'gray'
                                                        }}
                                                           align='right'>{`${product.markets.name}`}</p>
                                                    ) :
                                                    ""
                                                }


                                                {product.del_price > 0 ?
                                                    (
                                                        <React.Fragment>
                                                            <p key={product.id} style={{
                                                                fontSize: 12,
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                color: 'gray'
                                                            }}
                                                               align='left'>
                                                                <strong>{`${product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان `}</strong>
                                                            </p>

                                                            <p key={product.id} style={{
                                                                fontSize: 14,
                                                                overflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                color: 'green'
                                                            }}
                                                               align='left'>
                                                                <strong>{`${(parseInt(product.price) - parseInt(product.del_price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} تومان `}</strong>
                                                            </p>
                                                        </React.Fragment>

                                                    ) :
                                                    <React.Fragment>
                                                        <p key={product.id} style={{
                                                            fontSize: 14,
                                                            overflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            color: 'green'
                                                        }}
                                                           align='left'>
                                                            <strong>{`${product.price > 0 ? product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ` تومان ` : `تماس بگیرید.`}`}</strong>
                                                        </p>
                                                    </React.Fragment>
                                                }




                                            </ListItemText>
                                        </Box>

                                    </ListItem>

                                ))
                                }


                            </List>
                        </Box>

                    ))

                }

                {
                    this.state.searchResultMarket.map((market) => (
                        <div key={market.id} style={{overflowX: 'hidden', overflowY: 'hidden', height: 300}}>
                            <ListItemText><strong>{market.category} </strong></ListItemText>

                            <List key={market.id} style={flexContainer}>
                                {market.marketList.map((market) => (

                                    <ListItem key={market.id} style={{width: 170}} component={Link}
                                              to={"/market/?id=" + market.id}>
                                        <div style={{width: 150}}>
                                            <Paper style={{
                                                width: 150,
                                                height: 140,
                                                align: 'center',
                                                backgroundPosition: 'center',
                                                backgroundSize: 'cover',
                                                backgroundImage: 'url(' + (market.pictures.length > 0 ? MARKET_BASE_URL_API + market.pictures[0].url : "https://hamekara.com/hamekara-logo.png") + ')'
                                            }}>


                                            </Paper>
                                            <ListItemText>
                                                <p key={market.id}
                                                   style={{overflow: 'ellipsis', whiteSpace: 'nowrap', color: 'black'}}
                                                   align='center'>{market.name}</p>
                                            </ListItemText>
                                        </div>

                                    </ListItem>

                                ))
                                }
                            </List>
                        </div>

                    ))
                }


            </Box>

        </React.Fragment>;

    }
}
